import React from 'react';
import {get} from 'lodash';
import className from 'classnames';

class Logo extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  state = {
    isActive: false,
  };

  render = () => {
    return (
      <div
        className={className('Logo', {
          'ClickOpenPanel': true,
          'ClickOpenPanel--active': this.state.isActive,
        })}
      >
        <h1 className='Logo__h1'>
          <a
            className=''
            className={className('Logo__h1__a', {
              [`Logo__h1__a--${gon.currentProvider}`]: gon.currentProvider,
            })}
            onClick={() => {
              this.setState((prevState) => ({
                isActive: !prevState.isActive,
              }))
            }}
          >
            {gon.currentProvider}
          </a>
        </h1>

        <ul className='ClickOpenPanel__panel'>
          {get(this.props, 'providers', []).map((provider, key) => (
            <li key={key}>
              <a
                className={className('ClickOpenPanel__panel__a', {
                  'ClickOpenPanel__panel__a--active': true,
                })}
                href={`/${provider.toLowerCase()}/dashboard`}
              >
                {provider}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default Logo;
